/* global graphql */

import React from 'react';
import Features from '../components/features';
import SectionContainer from '../components/section-container';
import SectionPortfolio from '../components/section-portfolio';
import SectionQuestions from '../components/section-questions';
import SectionCta from '../components/section-cta';
import '../static/css/css/all.css'

const IndexPage = (props) => {
	//console.log('props en def', props);
	return (
		<main id="main-content">
	    	<Features data={props.data.allDataJson.edges[0].node.en[1]} />
			<SectionContainer data={props.data.allDataJson.edges[0].node.en[2]} />
			<SectionPortfolio data={props.data.allDataJson.edges[0].node.en[3]} />
			<SectionQuestions data={props.data.allDataJson.edges[0].node.en[4]}  datab={props.data.allDataJson.edges[0].node.en[5]}/>
			<SectionCta data={props.data.allDataJson.edges[0].node.en[6]}/>
		</main> )
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexQueryEn {
    allDataJson {
    edges {
      node {
        en {
          title
          parts {
            id
            title
            content
            link
            social
            image
            list
            description
          }
          ctabutton
        }
      }
    }
  }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/index.en.js